import TipTapLink from '@tiptap/extension-link';
import { mergeAttributes } from '@tiptap/core';

export enum MODE_TYPES {
    LINK = 'link',
    BUTTON = 'button'
}

export enum BUTTON_SIZE_TYPES {
    LARGE = 'large',
    EXTRA_LARGE = 'extra_large'
}

export const DEFAULT_BACKGROUND_COLOR = '#4F46E5'

const invertColor = (hexColor: string) => {
  const color = hexColor.substring(1);

  let r = parseInt(color.substring(0, 2), 16);
  let g = parseInt(color.substring(2, 4), 16);
  let b = parseInt(color.substring(4, 6), 16);
  
  // https://stackoverflow.com/a/3943023/112731
  return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '#000000' : '#FFFFFF';
}

const computeAttributes = ({ mode = MODE_TYPES.LINK, size = BUTTON_SIZE_TYPES.LARGE, backgroundColor = DEFAULT_BACKGROUND_COLOR, trackConversion = false, ...restAttributes }) => {
  const commonAttributes = {
    ...restAttributes,
    ...(trackConversion ? {'data-action': 'cta'} : {}),
  }
  
  if (mode === MODE_TYPES.BUTTON) {
    return {
        ...commonAttributes,
        class: `contimo-button${size === BUTTON_SIZE_TYPES.EXTRA_LARGE ? ' contimo-button-large' : ''}`,
        style: `
        color: ${invertColor(backgroundColor)};
        background-color: ${backgroundColor};
        `.replace(/[\s]{2,}/g, ''),
      }
    }

    return commonAttributes
}

const Link = TipTapLink.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            trackConversion: {
                default: true
            },
            mode: {
                default: null
            },
            backgroundColor: {
                default: null
            },
            size: {
                default: null
            }
        }
    },

    renderHTML({ HTMLAttributes }) {

        return [
            'a',
            mergeAttributes(this.options.HTMLAttributes, computeAttributes(HTMLAttributes)),
            0
        ]
    }
});

export default Link;
